<template>

  <div class="wrap">
    <div class="details-header">
      <router-link :to="'/'">立即查册</router-link>
      <router-link :to="'record'">过往查册记录</router-link>
    </div>
    <div class="details-content">
      <ul>
        <li>
          <select name=""  v-model="area">
            <option value="请选择区域">请选择区域</option>
            <option value="越秀区">越秀区</option>
            <option value="天河区">天河区</option>
            <option value="白云区">白云区</option>
            <option value="荔湾区">荔湾区</option>
            <option value="萝岗区">萝岗区</option>
            <option value="黄浦区">黄浦区</option>
            <option value="海珠区">海珠区</option>
            <option value="番禺区">番禺区</option>
            <option value="花都区">花都区</option>
            <option value="南沙区">南沙区</option>
            <option value="增城区">增城区</option>
            <option value="从化区">从化区</option>
          </select>
        </li>
        <li>
          <input type="text" placeholder="请输入产权人姓名(完整)" v-model="houseName">
        </li>
        <li>
          <input type="text" placeholder="请输入物业地址(完整)" v-model="houseAddress">
        </li>
        <li>
          <input type="text" placeholder="请输入房产证号" v-model="houseNum">
        </li>
        <li class="font-num">
          <select name="" id="" v-model="fontType">
            <option value="2017登记">2017登记</option>
            <option value="2016登记">2016登记</option>
            <option value="2015登记">2015登记</option>
            <option value="2014登记">2014登记</option>
            <option value="2013登记">2013登记</option>
            <option value="2012登记">2012登记</option>
            <option value="2011登记">2011登记</option>
            <option value="2010交登">2010交登</option>
            <option value="2010登记">2010登记</option>
            <option value="2009交登">2009交登</option>
            <option value="2009登记">2009登记</option>
            <option value="2008交登">2008交登</option>
            <option value="2008登记">2008登记</option>
            <option value="2007交登">2007交登</option>
            <option value="2007登记">2007登记</option>
            <option value="2006交登">2006交登</option>
            <option value="2006登记">2006登记</option>
            <option value="2005交登">2005交登</option>
            <option value="2005登记">2005登记</option>
            <option value="2004交登">2004交登</option>
            <option value="2004登记">2004登记</option>
            <option value="2003交登">2003交登</option>
            <option value="2003登记">2003登记</option>
            <option value="2002交登">2002交登</option>
            <option value="2002登记">2002登记</option>
            <option value="补">补</option>
            <option value="定">定</option>
            <option value="繁">繁</option>
            <option value="芳统">芳统</option>
            <option value="富">富</option>
            <option value="黄统">黄统</option>
            <option value="强">强</option>
            <option value="荣">荣</option>
            <option value="天统">天统</option>
            <option value="统">统</option>
            <option value="稳">稳</option>
            <option value="云统">云统</option>
            <option value="无登记字号">无登记字号</option>
          </select>
          <div>
            登记字号
            <input type="text" v-model="houseRegisterText">
          </div>
        </li>
        <li class="up_file">
          <span>上传房产证复印件</span><img v-if="fyjimg" :src="'http://www.gzmeize.com/'+fyjimg" height="100%">
          <form  method="post" name="form1">
            <p>
                
				  <input type="file" accept="image/*" name="bfuyinj" ref="file" id="upload_file" style="display:none" @change="upload()">
				  <button type="button" id="select_file" onclick="upload_file.click()" class="file">选择文件</button>
                 
            </p>
          </form>
        </li>
        <li>
          <select name=""  v-model="getnot">
            <option value="不取回查册纸">不取回查册纸</option>
            <option value="取回查册纸">取回查册纸</option>
          </select>
        </li>
        <li v-show="getnot=='取回查册纸'">
          <input type="text" placeholder="请输入收件地址" v-model="takeAdress">
        </li>
        <li v-show="getnot=='取回查册纸'">
          <input type="text" placeholder="请输入联系人姓名" v-model="takeName">
        </li>
        <li v-show="getnot=='取回查册纸'">
          <input type="text" placeholder="请输入联系电话" v-model="takePhone">
        </li>
      </ul>
      <button class="submitInfo" v-on:click="sendInfo">提交</button>

      <button style="margin-top: 30px" class="submitInfo" v-on:click="quit">退出</button>

    </div>
    <footerDiv></footerDiv>
    <div class="shade" v-show="parseInt(loading)">
      <clip-loader :loading="true" :color="'#c81623'" :size="'35px'"></clip-loader>
    </div>
  </div>

</template>

<script>
  import footerDiv from '../component/footer'
  import clipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    data () {
      return {
        area:'请选择区域', //区域
        houseName:'',   //请输入产权人姓名
        houseAddress:'',  //请输入物业地址
        houseNum:'',  //请输入房产证号
        fontType:'2017登记', //请选择字号类型
        houseRegisterText:'', //登记字号
        getnot:'不取回查册纸', //取不取查册
        fyjimg:'', //复印件图片
        seaState:'', // 取不取回查册
        takeAdress:'', // 收件人地址
        takeName:'', // 收件人名字
        takePhone:'', // 收件人电话
        loading:null
      }
    },
    components: {footerDiv,clipLoader},
    mounted:function(){
      $('#app .wrap .details-content').css('min-height',window.screen.height)
    },
    methods: {
      sendInfo (){
        var that = this
        if(that.getnot == '不取回查册纸'){
          that.seaState = 0
        }else{
          that.seaState = 1
        }

        if(this.seaState == 1){
          if(this.takeAdress == ''){
            alert('请输入收件人地址')
            return
          }else if(this.takeName == ''){
            alert('请输入收件人名字')
              return
          }else if(this.takePhone == ''){
            alert('请输入收件人电话')
            return
          }
        }
 

        if(this.fyjimg == ''){
          alert('请上传房产证复印件')
          return
        }

        if(this.area == '请选择区域'){
          alert('请选择区域')
          return
        }else if(this.houseRegisterText == ''){
          alert('请填写登记字号')
          return
        }else if(this.houseNum == ''){
          alert('请填写房产证号')
          return
        }else if(this.houseName == ''){
          alert('请填写产权人姓名')
          return
        }else if(this.houseAddress == ''){
          alert('请输入物业地址')
          return
        }

        $.post('http://www.gzmeize.com/ziyu.php?Action=pbook',
          {
            userUserID:window.localStorage.userUserID,
            bquyu:that.area,
            bchanquanxm:that.houseName,
            bwuyedz:that.houseAddress,
            bchanchangzh:that.houseNum,
            bzihaolx:that.fontType,
            bdengjizh:that.houseRegisterText,
            bchazhi:that.seaState,
            bshoujianr:that.takeName,
            bdianhua:that.takePhone,
            bdizhi:that.takeAdress,
            bfuyinj:el
          },
          function(data) {
            alert(JSON.parse(data).msg)
//            console.log(data)
          })
      },
      quit (){
        localStorage.userUserID = ''
        this.$router.push({path: './login'})
      },
	  upload (){
		if(this.$refs.file.files.length>0){
			var form=new FormData()
			form.append('bfuyinj',this.$refs.file.files[0])
			var self = this
			$.ajax({
                url:'http://www.gzmeize.com/ziyu.php?Action=aphoto',
                type:'post',
				processData:false,
				contentType:false, 
                data:form,
                success:function (data) {
					self.fyjimg=JSON.parse(data).photo
					
			
                }
            })
		}
	}
    },
	
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
    @import "../reset"
    @import "./details"
</style>



// WEBPACK FOOTER //
// src/components/details/details.vue